
import React, { useEffect } from 'react';
import Header from '@/components/Header';
import FormCompleted from '@/components/FormCompleted';
import { supabase } from '@/integrations/supabase/client';

const Confirmation = () => {
  useEffect(() => {
    // Sign out the user once they land on the confirmation page
    const signOutUser = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          await supabase.auth.signOut();
        }
      } catch (error) {
        console.error('Error signing out user:', error);
      }
    };

    signOutUser();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8">
        <FormCompleted />
      </main>
      
      <footer className="bg-white py-4 border-t">
        <div className="container mx-auto px-4">
          <p className="text-center text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Figabl. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Confirmation;
